import { ShowContextProvider, Title, useEditController } from "react-admin";
import { useParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { PageTopBreadcrumb } from "../../components/PageTopBreadcrumb";
import { IdChip } from "../../components/IdChip";
import { colors } from "../../data/tokens";
import { transactionCategoryColor } from "../transactions/transactions-util";

// Ficha no padrão das Categorias de Sócios: nome em destaque com o chip
// colorido da família e o identificador técnico copiável — a versão
// antiga listava "Id" e "Name" crus, em inglês.
export const TransactionCategoryShow = () => {
  const { id } = useParams();
  const controller: any = useEditController({
    resource: "transaction-categories/crud",
    id,
  });
  const record = controller?.record;

  return (
    <ShowContextProvider value={controller}>
      <Title title="Categorias de Transações" />
      <PageTopBreadcrumb
        title="Categorias de Transações"
        firstPath="/#/transaction-categories/crud"
        secondTitle="Visualizando"
        thirdTitle={record?.name}
        actionType="edit"
      />
      {record && (
        <Card sx={{ marginBottom: 3 }}>
          {/* Box em vez de CardContent: o App.css zera o padding de todo
              .MuiCardContent-root com !important */}
          <Box sx={{ padding: { xs: 2.5, md: 4 } }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                flexWrap: "wrap",
              }}
            >
              <Typography
                noWrap
                sx={{
                  fontSize: 17,
                  fontWeight: 700,
                  color: colors.primaryDark,
                }}
              >
                Categoria de Transações
              </Typography>
              <Chip
                size="small"
                variant="outlined"
                color={transactionCategoryColor(record.name)}
                label={record.name}
              />
            </Box>

            <Divider sx={{ marginY: 2.5 }} />

            <Typography sx={{ fontSize: 12, color: colors.textMuted }}>
              Identificador técnico
            </Typography>
            <Box sx={{ marginTop: 0.5 }}>
              <IdChip value={record.id} />
            </Box>
          </Box>
        </Card>
      )}
    </ShowContextProvider>
  );
};
